<template>
    <div class="d-flex" id="form-wrapper" v-if="productData">
        <IntroSection :product-data="productData" />
        <RatingSection :title="productData.product_name" @update-form="updateForm" />
        <TitleSection @update-form="updateForm" />
        <CommentSection @update-form="updateForm" />

        <div v-for="question in questions">
            <GeneralSingleChoiceQuestion
                v-if="question.type === 1"
                :data="question"
                @update-form="updateFormAnswers({ id: question.id, value: $event })"
            />
            <GeneralMultipleChoiceQuestion
                v-if="question.type === 2"
                :data="question"
                @update-form="updateFormAnswers({ id: question.id, value: $event })"
            />
            <GeneralBinaryQuestion
                v-if="question.type === 3"
                :data="question"
                @update-form="updateFormAnswers({ id: question.id, value: $event })"
            />
            <GeneralScaleQuestion
                v-if="question.type === 4"
                :data="question"
                @update-form="updateFormAnswers({ id: question.id, value: $event })"
            />
        </div>

        <UploadMediaSection @update-form="updateForm" />

        <FooterSection :missing-fields="missingRequiredFields" @handle-form="handleForm" />
    </div>
</template>

<script>
    import CommentSection from './form-sections/CommentSection.vue';
    import FooterSection from './form-sections/FooterSection.vue';
    import GeneralBinaryQuestion from './form-sections/GeneralBinaryQuestion.vue';
    import GeneralMultipleChoiceQuestion from './form-sections/GeneralMultipleChoiceQuestion.vue';
    import GeneralScaleQuestion from './form-sections/GeneralScaleQuestion.vue';
    import GeneralSingleChoiceQuestion from './form-sections/GeneralSingleChoiceQuestion.vue';
    import IntroSection from './form-sections/IntroSection.vue';
    import RatingSection from './form-sections/RatingSection.vue';
    import TitleSection from './form-sections/TitleSection.vue';
    import UploadMediaSection from './form-sections/UploadMediaSection.vue';

    export default {
        name: 'AvaliacoesForm',
        props: {
            avaliation: {
                type: Object,
            },
        },

        components: {
            RatingSection,
            IntroSection,
            CommentSection,
            TitleSection,
            UploadMediaSection,
            GeneralBinaryQuestion,
            GeneralScaleQuestion,
            GeneralSingleChoiceQuestion,
            GeneralMultipleChoiceQuestion,
            FooterSection,
        },

        data() {
            return {
                formData: {
                    stars: 0,
                    recommend: null,
                    title: null,
                    review: null,
                    upload: null,
                },

                questions: [],

                answers: {},

                missingRequiredFields: false,

                observerTarget: null,
                observer: null,
            };
        },

        computed: {
            productData() {
                if (!this.avaliation) {
                    return null;
                }
                const productId = parseInt(this.$route.params.productId);

                return this.avaliation.products.find((p) => p.product_id === productId);
            },
        },

        created() {
            if (!this.productData || this.productData.note) {
                this.$router.push({ name: 'home', query: this.$route.query });
                return;
            }

            this.getQuestions();
        },

        mounted() {
            this.observerTarget = document.querySelector('.intro-title');
            if (this.observerTarget) {
                this.observer = new IntersectionObserver(this.handleIntersection, {
                    root: null,
                    rootMargin: '-20px',
                    threshold: 1,
                });

                this.observer.observe(this.observerTarget);
            }
        },

        beforeDestroy() {
            if (this.observer && this.observerTarget) {
                this.observer.unobserve(this.observerTarget);
            }
        },

        methods: {
            handleIntersection(entries) {
                entries[0].isIntersecting
                    ? this.updateHeaderInfo(false)
                    : this.updateHeaderInfo(true);
            },

            updateHeaderInfo(value) {
                if (this.productData) {
                    this.$emit('update-header-info', value, this.productData.product_name);
                }
            },

            updateForm({ field, value }) {
                this.formData[field] = value;
            },

            updateFormAnswers({ id, value }) {
                this.answers[id] = value;
            },

            getQuestions() {
                if (!this.productData) {
                    return;
                }

                this.productData.questions.map((question) => {
                    this.questions.push({
                        id: question.id,
                        type: question.type,
                        title: question.title,
                        description: question.description,
                        options: question.comment_question_option,
                    });

                    this.answers[question.id] = null;
                });
            },

            checkRequiredFields() {
                return !this.formData.stars || this.formData.recommend === null;
            },

            handleForm() {
                if (this.checkRequiredFields()) {
                    this.missingRequiredFields = true;
                    return;
                }

                this.missingRequiredFields = false;

                this.$emit(
                    'update-product',
                    this.productData.product_id,
                    this.formData,
                    this.answers
                );
            },
        },
    };
</script>
